import { __decorate, __metadata } from "tslib";
import { SingletonService } from '@trp-dms-digital-shared/ds-ui-library-common';
import { gql } from '@apollo/client/core/index.js';
import { DadaApiService } from './dada-api.service.js';
let ApiService = class ApiService extends DadaApiService {
    request = {};
    constructor(endpoint, apikey) {
        super(endpoint, apikey);
    }
    getQuery() {
        return gql `query getProduct($productRequest: DataRequest) {
      fetchData(req: $productRequest) {
        type
        ${this.fragments}
      }
    }`;
    }
    updateRequest(newRequest, productFragment) {
        this.request = {
            ...this.request,
            ...newRequest,
        };
        this.fragments = this.fragments.concat(productFragment);
        if (!this.timeOutSet) {
            setTimeout(() => {
                let response = {};
                const apiQueryObservable = this.apolloClient.watchQuery({
                    query: gql `
            ${this.getQuery()}
          `,
                    variables: {
                        productRequest: {
                            type: 'productRequest',
                            context: {
                                audience: this.request.context?.audience,
                                country: this.request.context?.country,
                                language: this.request.context?.language,
                            },
                            productRequest: {
                                productCode: this.request.productCode,
                                historicalDates: this.request.historicalDates,
                            },
                        },
                    },
                });
                apiQueryObservable.subscribe((results) => {
                    response = results?.data?.fetchData;
                    this.apiSubject.next(response);
                    this.request = {};
                    this.timeOutSet = false;
                }, (error) => {
                    console.error('api.service - updateRequest', error);
                    this.request = {};
                    this.timeOutSet = false;
                });
            }, this.timeOutSetting);
            this.timeOutSet = true;
        }
    }
};
ApiService = __decorate([
    SingletonService,
    __metadata("design:paramtypes", [String, String])
], ApiService);
export { ApiService };
//# sourceMappingURL=product-request-api.service.js.map